import { InputBase, Stack, useTheme } from "@mui/material";
import { Search } from "lucide-react";
import type { ChangeEvent, FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	value: string;
	onChange: (value: string) => void;
};

export const ChatListSearch: FC<Props> = ({ value, onChange }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			flexShrink={0}
			px={1.6}
			pt={0.8}
			pb={0.8}
			bgcolor={theme.palette.surface.muted}
		>
			<InputBase
				fullWidth
				value={value}
				onChange={(event: ChangeEvent<HTMLInputElement>) =>
					onChange(event.target.value)
				}
				placeholder={t(Resources.Chat.searchPlaceholder)}
				startAdornment={
					<Search
						size={theme.iconSize.sm}
						color={theme.palette.grey[400]}
						style={{ flexShrink: 0, marginRight: 8 }}
					/>
				}
				sx={{
					px: 1.2,
					py: 0.8,
					fontSize: 14,
					bgcolor: theme.palette.grey[100],
					borderRadius: theme.shape.pillRadius,
					"& input": { p: 0 },
					"& input::placeholder": {
						color: theme.palette.grey[400],
						opacity: 1,
					},
				}}
			/>
		</Stack>
	);
};
